import React from 'react';
import { DESTINATION_TYPES } from '../../destination/constants/destinationTypes';
import { getNodeTypeLogoInfo } from '../../../core/utils/nodeTypeUtils';
import { TRACKER_INTRODUCTION_CREATE_ACTIVATION_CLICK } from '../tracking';
import { ACTIVATION_DOC } from '../../../core/constants/constants';
import { RbacPermissions } from '../../../core/interfaces/user';
import { CreateActivateAngularticsService } from '../../../core/services/create-activate-angulartics.service';
import { SessionTrackingAngularticsService } from '../../../core/services/session-tracking-angulartics.service';
import { FEATURED_TARGET_LOGO_LISTS, FEATURED_WAREHOUSE_LOGO_LISTS } from '../constants/featuredData';
import { TARGET_TYPES } from '../../activate-target/models/target-type';
import { AngularDiProviders } from '../../../injector/components/angular-di/AngularDiProviders';
import { NodeLogo } from '@hevoio/hevo-ui-toolkit';
import { HdDocLink, HdIcon, HdRbacButton } from '../../../components';
import useService from '../../../injector/hooks/useService';
import styles from './ActivateTour.module.scss';

const docLink = ACTIVATION_DOC;
const warehousesList = FEATURED_WAREHOUSE_LOGO_LISTS.map(warehouseType =>
  getNodeTypeLogoInfo(warehouseType, DESTINATION_TYPES)
);

const targetsList = FEATURED_TARGET_LOGO_LISTS.map(targetType =>
  getNodeTypeLogoInfo(targetType, TARGET_TYPES)
);

const angularDIProviders = [
  {
    provide: SessionTrackingAngularticsService,
    useExisting: CreateActivateAngularticsService
  }
];

export function ActivateTour(props) {
  return (
    <AngularDiProviders providers={angularDIProviders}>
      <ActivateTourInner {...props} />
    </AngularDiProviders>
  );
}

function ActivateTourInner({ onAddClick, hideCaption }) {
  const createActivateAngularticsService = useService(CreateActivateAngularticsService);

  const _onAddClick = () => {
    createActivateAngularticsService.startSessionAndTrack({
      action: TRACKER_INTRODUCTION_CREATE_ACTIVATION_CLICK
    });

    onAddClick();
  };

  return (
    <div className='entity-intro-box-wrapper'>
      <div className='entity-intro-box'>
        <div className='left'>
          {!hideCaption ? <div className='entity-intro-box-caption'>ACTIVATE</div> : null}

          <div className={styles.entityIntroBoxTitle}>Sync data from your Warehouse to Target</div>

          <div className={`${styles.entityIntroBoxBody} entity-intro-box-body`}>
            Synchronize and enrich data from your Warehouse to a Target.{' '}
            <HdDocLink dataId='activation-tour' docLink={docLink} section='activation_create' />
          </div>

          <div className='center-flex-row mb-7'>
            <div className='center-flex-row'>
              {warehousesList.map(warehouse => (
                <div className={styles.nodeLogoWrapper}>
                  <NodeLogo
                    roundedBorders
                    logoURL={warehouse.logoURL}
                    darkModeLogoURL={warehouse.logoURL}
                    primaryColor={warehouse.primaryColor}
                    darkModePrimaryColor={warehouse.primaryColorDarkMode}
                  />
                </div>
              ))}
            </div>

            <HdIcon name='pipeline-connection' className='text-success mx-5' size={3} />

            <div className='center-flex-row'>
              {targetsList.map(target => (
                <div className={styles.nodeLogoWrapper}>
                  <NodeLogo
                    roundedBorders
                    logoURL={target.logoURL}
                    darkModeLogoURL={target.logoURL}
                    primaryColor={target.primaryColor}
                    darkModePrimaryColor={target.primaryColorDarkMode}
                  />
                </div>
              ))}
            </div>
          </div>

          <HdRbacButton
            dataId='create-activation'
            icon='plus'
            className='entity-intro-box-action'
            rbacPermission={RbacPermissions.ACTIVATION_CREATE}
            onClick={_onAddClick}
          >
            Create Activation
          </HdRbacButton>
        </div>

        <div className='right__video flex-col'>
          <div className={`${styles.entityIntroBoxIllustration} entity-intro-box-illustration`}>
            <iframe
              width='100%'
              height='100%'
              src='https://www.youtube.com/embed/oQVdtmIUsgo'
              title='Activate Tour'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
            />
          </div>

          <span className='center-flex-row justify-center text-secondary'>
            Watch the Product Demo
          </span>
        </div>
      </div>
    </div>
  );
}
